<span class="menu-item-content">
  @if (svg()) {

  <ssc-icon class="!text-inherit" [svg]="svg()" />

  } @if (!iconOnly()) {
  <ng-content></ng-content>
  }
</span>
